import { createSelector } from 'reselect'

const getStudentViewData = state => state.student
const getSlideId = (state, slide_uid) => slide_uid

const studentDawItSubmitSelector = createSelector(
	[ getStudentViewData, getSlideId ],
	(student, slideId) => {
		const slide_data = student.slides[slideId]

		return {
			device_uid: student.device_uid,
			headers: student.headers,
			answers: slide_data.answers,
			backgroundImage: slide_data.backgroundImage,
		}
	}
)

export default studentDawItSubmitSelector
